/** @jsx jsx */
import React from 'react'
import { jsx, Flex, Box } from 'theme-ui'
import { PlayingCard } from '../../components/PlayingCard'
import { Positioned } from '../../components/Positioned'
import { ClientGameHandController } from '../../controllers/ClientGameHandController'
import { IPositionProps } from './positionProps'
import { Txt } from '../../components'
import { theme } from '../../gatsby-plugin-theme-ui/theme'
import { rgba } from 'polished'
import { getUserHandSolution } from '../../utils/getUserHandSolution'

export const VisibleSolvedUserHands: React.FC<
  IPositionProps & {
    controller: ClientGameHandController
  }
> = ({ otherUserPositioning, controller, measurements, ...props }) => {
  if (!controller.gameHand.finalResult) {
    return null
  }
  const visibleHands = [
    ...controller.gameHand.finalResult.automaticallyVisibleUserHands,
    ...(controller.gameHand.finalResult.manuallyVisibleUserHands || []),
  ]
  return (
    <React.Fragment>
      {visibleHands.map((solvedHand) => {
        const userData = controller.getUserData(solvedHand.userId)
        return (
          <Positioned
            key={userData.id}
            width={200}
            height={80 + 30}
            coords={userData.calcPositionFromPixels(-60)}
            sx={{ zIndex: 3 }}
          >
            <Flex sx={{ alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <Box>
                {solvedHand.cards.map((card, index) => (
                  <PlayingCard
                    key={index}
                    sx={{ ml: index ? 2 : 0 }}
                    width={measurements.playingCardWidth}
                    card={card}
                  />
                ))}
              </Box>
              <Txt
                sx={{
                  textAlign: 'center',
                  mt: 2,
                  fontSize: [0, 0, 1],
                  py: 2,
                  px: 3,
                  bg: `${rgba(theme.colors.darkBlue, 0.85)}`,
                  borderRadius: 'pill',
                  color: 'white',
                }}
              >
                {
                  getUserHandSolution({ cards: solvedHand.cards, gameHand: controller.gameHand })
                    .descr
                }
              </Txt>
            </Flex>
          </Positioned>
        )
      })}
    </React.Fragment>
  )
}
